import { BasicShadowMap, PCFShadowMap, PCFSoftShadowMap, VSMShadowMap } from 'three';

export const shadowMapTypeValues = {
    BasicShadowMap,
    PCFShadowMap,
    PCFSoftShadowMap,
    VSMShadowMap,
};

export const shadowMapTypeNames: { [v: number]: ShadowMapType } = {};
Object.keys(shadowMapTypeValues).forEach((k: ShadowMapType) =>
{
    shadowMapTypeNames[shadowMapTypeValues[k]] = k;
});

export type ShadowMapType = keyof typeof shadowMapTypeValues;
